"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PropTypes = require('prop-types');

var React = require('react');

var _ = require('lodash');

var classNames = require('classnames');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var BaseModal = require('../baseModal/baseModal');

var Text = require('../text/text');

var Heading = require('../heading/heading');

var _require = require('./constants'),
    dataHooks = _require.dataHooks;

var THEMES = ['standard', 'destructive', 'premium'];

var MessageModal = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(MessageModal, _React$PureComponent);

  var _super = _createSuper(MessageModal);

  function MessageModal() {
    _classCallCheck(this, MessageModal);

    return _super.apply(this, arguments);
  }

  _createClass(MessageModal, [{
    key: "_renderContent",
    value: function _renderContent() {
      var _this$props = this.props,
          title = _this$props.title,
          content = _this$props.content,
          illustration = _this$props.illustration;
      return /*#__PURE__*/React.createElement(React.Fragment, null, illustration && /*#__PURE__*/React.createElement(React.Fragment, null, _.isString(illustration) ? /*#__PURE__*/React.createElement("img", {
        className: "control-message-modal-image",
        "data-hook": dataHooks.illustrationSrc,
        src: illustration
      }) : /*#__PURE__*/React.createElement("div", {
        className: "control-message-modal-illustration",
        "data-hook": dataHooks.illustration
      }, illustration)), /*#__PURE__*/React.createElement("div", {
        className: "control-message-modal-content-wrapper"
      }, title && /*#__PURE__*/React.createElement("div", {
        className: "control-message-modal-title"
      }, /*#__PURE__*/React.createElement(Heading, {
        dataHook: dataHooks.title,
        appearance: "h2",
        multiline: true,
        shouldTranslate: false
      }, title)), content && /*#__PURE__*/React.createElement("div", {
        className: "control-message-modal-content",
        "data-hook": dataHooks.content
      }, _.isString(content) ? /*#__PURE__*/React.createElement(Text, {
        dataHook: dataHooks.contentText,
        size: "medium",
        weight: "normal",
        skin: "secondary",
        enableEllipsis: false,
        shouldTranslate: false
      }, content) : content)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          dataHook = _this$props2.dataHook,
          getClassName = _this$props2.getClassName,
          theme = _this$props2.theme,
          illustration = _this$props2.illustration,
          sideActions = _this$props2.sideActions,
          footnote = _this$props2.footnote,
          onCloseButtonClick = _this$props2.onCloseButtonClick,
          onHelpButtonClick = _this$props2.onHelpButtonClick,
          primaryButtonText = _this$props2.primaryButtonText,
          primaryButtonProps = _this$props2.primaryButtonProps,
          primaryButtonOnClick = _this$props2.primaryButtonOnClick,
          secondaryButtonText = _this$props2.secondaryButtonText,
          secondaryButtonProps = _this$props2.secondaryButtonProps,
          secondaryButtonOnClick = _this$props2.secondaryButtonOnClick;
      return /*#__PURE__*/React.createElement(BaseModal, {
        dataHook: dataHook,
        theme: theme,
        sideActions: sideActions,
        footnote: footnote,
        onCloseButtonClick: onCloseButtonClick,
        onHelpButtonClick: onHelpButtonClick,
        primaryButtonText: primaryButtonText,
        primaryButtonProps: primaryButtonProps,
        primaryButtonOnClick: primaryButtonOnClick,
        secondaryButtonText: secondaryButtonText,
        secondaryButtonProps: secondaryButtonProps,
        secondaryButtonOnClick: secondaryButtonOnClick,
        className: getClassName(classNames('control-message-modal', {
          'with-illustration': illustration
        }))
      }, this._renderContent());
    }
  }]);

  return MessageModal;
}(React.PureComponent);

MessageModal.displayName = displayNames.MESSAGE_MODAL;
MessageModal.propTypes = {
  /** Hook for testing purposes  */
  dataHook: PropTypes.string,

  /** A css class to be applied to the component's root element */
  className: PropTypes.string,

  /** A global theme for the modal */
  theme: PropTypes.oneOf(THEMES),

  /** The modal's title */
  title: PropTypes.string.isRequired,

  /** The content of the MessageModal */
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** The illustration src or the illustration node itself */
  illustration: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** side actions node, to be rendered as the first element on the same row as the action buttons */
  sideActions: PropTypes.node,

  /** a footnote node, to be rendered at the very bottom of the modal */
  footnote: PropTypes.node,

  /** callback for when the close button is clicked */
  onCloseButtonClick: PropTypes.func,

  /** callback for when the help button is clicked */
  onHelpButtonClick: PropTypes.func,

  /** a text for the primary action button */
  primaryButtonText: PropTypes.string.isRequired,

  /** Passed to the primary action button as props without any filter / mutation */
  primaryButtonProps: PropTypes.object,

  /** callback for when the secondary action button is clicked */
  primaryButtonOnClick: PropTypes.func.isRequired,

  /** a text for the secondary action button */
  secondaryButtonText: PropTypes.string,

  /** Passed to the secondary button as props without any filter / mutation */
  secondaryButtonProps: PropTypes.object,

  /** callback for when the secondary action button is clicked */
  secondaryButtonOnClick: PropTypes.func
};
MessageModal.defaultProps = {
  dataHook: 'MessageModal',
  theme: 'standard'
};
module.exports = compose(MessageModal);